import { DataDRequest } from "../../../data/DRequest";
import { Entidad } from "../../../data/Entidad";
import { DataModuloMain } from "../../../data/ModuloMain";
import { _DICC_ESCUELA } from "../../../data/modulo/Escuela";
import { _LOCALDATA_GetAlumnosEnGrupo } from "../../../data/modulo/Grupo";
import { TCARDV2COLL_OnEditOriginEvent } from "../../controlD3/CardV2/CardV2Collapse";
import { CardV2CollapseAdvancedTable, IConfigCardV2CollapseExcelExport } from "../../controlD3/CardV2/CardV2CollapseAdvancedTable";
import { Table } from "../../controlD3/Tabla";
import { UIUtilGeneral } from "../../util/Util";
import { UIUtilViewData } from "../../util/ViewData";
import { UIUtilViewAlumno } from "../../utilView/Alumno";

import IAlumno = Entidad.IAlumno;
import IGrupo = Entidad.IGrupo;

export class UIPanelCardGruposAlumnosV2 extends CardV2CollapseAdvancedTable<IAlumno, [IGrupo]> {

    constructor(modulo: Entidad.CModulo) {
        super("card_headertitle", modulo, "grupopanel_alumnos");
    }

    protected CARDCOLLADTAB_Table_GetMenuTop(): Table.ITableMenuTopDefaultOptionConfig[] {
        return null;
    }
    protected CARDCOLLADTAB_GetExportarConfig(dataTable: IAlumno[]): IConfigCardV2CollapseExcelExport<any> | Promise<IConfigCardV2CollapseExcelExport<any>> {
        const grupo = this.cardData[0];
        return {
            FileName: grupo.Nombre + " - Alumnos",
            IdsEscuelas: [grupo.IdKinder],
            TypeRequest: Entidad.CTipoRequest.Grupo,
            ColumnsConfig: this.ctrlTabla._InfoColumns
                .filter(d => (d.Field != "getThumbnailURL"))
                .map(d => ({
                    Field: d.Field as keyof IAlumno,
                    HeaderTag: d.Label,
                    WidthCell: 25
                })),
            OnGetDataBySheets: async () => {
                return [{
                    IdSheet: grupo.IdKinder, // IdEscuela
                    SheetName: grupo.Nombre,
                    Data: dataTable,
                }]
            },
            OnGetEscuelasTagInSheet: (datos) => _DICC_ESCUELA.get(grupo.IdKinder).Nombre,
            OnStepFieldInDataRow: (field, dato) => {
                if (field == "FechaNacimiento" && dato[field]) {
                    return dato.getFechaNacimientoFmt;
                }
                return dato[field] as string;
            }
        }
    }
    protected CARDCOLLADTAB_Table_GetConfig(): Omit<Table.IConfig<IAlumno>, "Parent"> {
        return {
            IdTabla: "GruposPanelAlumos",
            IdData: "IdChild",
            OrderDefault: {
                Field: "NombreCompleto",
                Type: Table.CStatusOrder.Asc,
            },
            MinWidth: 700,
            RenderColumnHeadings: [
                { Field: "getThumbnailURL", Label: "", MinWidth: "45px", Width: "5%", IsSortable: false },
                { Field: "NombreCompleto", Label: "Nombre", MinWidth: "70px", Width: "30%" },
                { Field: "Matricula", Label: "Matrícula", MinWidth: "80px", Width: "20%" },
                { Field: "StrSexo", Label: "Sexo", MinWidth: "50px", Width: "15%" },
                { Field: "StrEstado", Label: "Estado", MinWidth: "60px", Width: "15%" },
                { Field: "FechaNacimiento", Label: "Nacimiento", MinWidth: "95px", Width: "20%" },
            ],
            OnValueSelectRow: (id, datum) => console.debug(id, datum),
            OptionsOfDataCheckV3: () => this.CARDCOLLADTAB_GetTableOptionsToSelectedData(this.cardData[0].IdKinder, "top-selected"),
            FilterParameters: [
                { LangModuleKeyInContext: "alumnos", LabelLangKey: "d_field_nombre", Field: "Nombre" },
                { LangModuleKeyInContext: "alumnos", LabelLangKey: "d_field_appaterno", Field: "ApPaterno" },
                { LangModuleKeyInContext: "alumnos", LabelLangKey: "d_field_apmaterno", Field: "ApMaterno" },
                { LabelLangKey: "d_field_matricula", Field: "Matricula" },
                {
                    LabelLangKey: "d_field_strsexo",
                    Field: "Sexo",
                    Type: "select",
                    Options: UIUtilViewData._GetList_Sexo()
                },
                {
                    LabelLangKey: "d_field_strestado",
                    Field: "IdChildMovimiento",
                    Type: "select",
                    Options: UIUtilViewData._GetList_EstadosMovimientos()
                        .filter(d => (
                            (d.Id == Entidad.CNinioMovimiento.Activo)
                            || (d.Id == Entidad.CNinioMovimiento.Preinscripcion)
                            || (d.Id == Entidad.CNinioMovimiento.BajaTemporal)))
                },
                { LabelLangKey: "d_field_fechanacimiento", Field: "FechaNacimiento", Type: "date", MaxDate: new Date().toISOString() },
            ],
            EvaluatorAndSubLevelsBuild: {
                // GetOptionsInRow: () => this.CARDCOLLAD_GetTableOptionsToSelectedData(this.cardData[0].IdKinder, "row"),
                OnStepCellTable: (container, datum, field: keyof IAlumno) => {
                    switch (field) {
                        case "getThumbnailURL":
                            UIUtilViewAlumno._UIUpdateFotoAlumno(container, datum);
                            break;
                        case "FechaNacimiento":
                            container.text(datum.getFechaNacimientoFmt);
                            break;
                        case "NombreCompleto":
                            UIUtilGeneral._ElementAdd_LinkToGoToPanel(container, "alumnos/alumnos/panel", datum.IdChild, datum.NombreCompleto);
                            break;
                    }
                }
            }
        }
    }
    protected CARDCOLL_OnInitBuild(container: TSelectionHTML<"div", any, any>): void {
        //this.cardHeaderSelection.remove();
        //this.cardActionsContainerSelection.style("top", "-32px");
        //this.cardSelection.style("height", "100%");

        this.btnEditarCard._d3Selection.remove();
        this.cardFooterSelection.remove();

        container.style("height", "100%");

    }
    protected CARDCOLL_GetVariantToValidateUpdate(cardData_0: IGrupo): string {
        return null;
    }
    protected CARDCOLL_OnUpdateData(grupo: IGrupo): void {
        this.ctrlTabla._UpdateData(Array.from(_LOCALDATA_GetAlumnosEnGrupo(grupo.IdGrupo).values()));
    }
    protected CARDCOLL_MostrarBody(): void {
        this.cardContentContainerSelection.style("height", "100%");
    }
    protected CARDCOLL_OcultarBody(): void {
        this.cardContentContainerSelection.style("height", null);
    }
    protected CARDCOLL_OnEditarCard(originEvent: TCARDV2COLL_OnEditOriginEvent): void {
        //throw new Error("Method not implemented.");
    }
    protected CARDCOLL_OnCancelaEditarCard(originEvent: TCARDV2COLL_OnEditOriginEvent): void {
        //throw new Error("Method not implemented.");
    }
    protected CARDCOLL_GuardarCardV2(): Promise<DataDRequest.IRequestResponseA<any>> {
        throw new Error("Method not implemented.");
    }
    protected CARDCOLL_SyncOrGetIdToDownloadData(): DataModuloMain.TipoRequestMonitorId | DataModuloMain.TipoRequestMonitorId[] | (() => Promise<any>) {
        return Entidad.CTipoRequest.HorarioAlumno;
    }
    protected CARDCOLL_GetIdSchool(cardData_0_0: IGrupo): number {
        return cardData_0_0.IdKinder;
    }
}
